import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enApps from './locales/en/apps.json';
import enChannelDetail from './locales/en/channel-detail.json';
import enCommon from './locales/en/common.json';
import enInviteAccept from './locales/en/invite-accept.json';
import enMembers from './locales/en/members.json';
import enOrgDetail from './locales/en/org-detail.json';
import enOrgSettings from './locales/en/org-settings.json';
import enProfile from './locales/en/profile.json';
import enSandbox from './locales/en/sandbox.json';
import enWebhooks from './locales/en/webhooks.json';
import enSend from './locales/en/send.json';
import enSub from './locales/en/sub.json';

/**
 * Minimal i18next bootstrap.
 *
 * The catalogues under `./locales/<locale>/<namespace>.json` are
 * **generated** from `l10n/strings/<locale>/frontend/<namespace>.yaml`
 * by `make frontend-l10n`. Never edit them by hand. The make target is
 * a phony prereq of typecheck/test/build/dev so a clean checkout always
 * has fresh JSON before any of those run.
 *
 * New locales drop into `l10n/strings/<locale>/frontend/<namespace>.yaml`
 * and get registered here. The list is deliberately explicit (no glob
 * magic) to make missing translations obvious in code review.
 */
export const DEFAULT_LOCALE = 'en';

export const SUPPORTED_LOCALES = ['en'] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

void i18n.use(initReactI18next).init({
  resources: {
    en: {
      apps: enApps,
      'channel-detail': enChannelDetail,
      common: enCommon,
      'invite-accept': enInviteAccept,
      members: enMembers,
      'org-detail': enOrgDetail,
      'org-settings': enOrgSettings,
      profile: enProfile,
      sandbox: enSandbox,
      webhooks: enWebhooks,
      send: enSend,
      sub: enSub,
    },
  },
  lng: DEFAULT_LOCALE,
  fallbackLng: DEFAULT_LOCALE,
  defaultNS: 'common',
  ns: [
    'apps',
    'channel-detail',
    'common',
    'invite-accept',
    'members',
    'org-detail',
    'org-settings',
    'profile',
    'sandbox',
    'send',
    'webhooks',
    'sub',
  ],
  interpolation: { escapeValue: false },
});

export default i18n;
